import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class WizardSteps {
  @bindable
  steps: string[];

  @bindable
  currentStep: number;
}
